import React from 'react'
import { css } from '@emotion/css'

const unlicensedCss = css`
  filter: blur(3px) grayscale(20%);
`

interface UnlicensedTitleProps {
  readonly title: string
  readonly ruleName: string
}

const UnlicensedTitle = ({ title, ruleName }: UnlicensedTitleProps) => {
  const [ruleTitle, unlicensedText] = title.split(/{{[#|\/]\w+}}/)
  // fallback to ruleName if parsing ruleTitle or unlicenseText fails

  return (
    <>
      {(unlicensedText && ruleTitle) || ruleName}
      <span className={unlicensedCss}>{unlicensedText}</span>
    </>
  )
}

interface VulnerabilityTitleProps {
  readonly title: string
  readonly ruleName: string
  readonly visible: boolean
}

export function VulnerabilityTitle({
  title,
  ruleName,
  visible
}: VulnerabilityTitleProps) {
  return (
    <>
      {visible ? title : <UnlicensedTitle ruleName={ruleName} title={title} />}
    </>
  )
}
